import { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

export function getHashScrollOffset() {
  const navbar = document.querySelector('.navbar');
  const navbarHeight = navbar ? navbar.offsetHeight : 80;
  const formationHeader = document.querySelector('.formation-detail-sticky-header');
  const formationHeaderHeight = formationHeader ? formationHeader.offsetHeight : 0;
  return navbarHeight + formationHeaderHeight + 16;
}

const useHashScroll = () => {
  const location = useLocation();

  const scrollToHash = useCallback((hash) => {
    if (!hash) return;

    const elementId = hash.replace('#', '');
    const element = document.getElementById(elementId);

    if (element) {
      const totalOffset = getHashScrollOffset();
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = Math.max(0, elementPosition - totalOffset);

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });

      element.style.transition = 'all 0.3s ease';
      element.style.transform = 'scale(1.02)';
      element.style.boxShadow = '0 4px 20px rgba(59, 130, 246, 0.2)';

      setTimeout(() => {
        element.style.transform = '';
        element.style.boxShadow = '';
      }, 1000);
    }
  }, []);

  useEffect(() => {
    if (location.hash) {
      const timer = setTimeout(() => {
        scrollToHash(location.hash);
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [location, scrollToHash]);

  const scrollToElement = (elementId) => {
    const hash = elementId.startsWith('#') ? elementId : `#${elementId}`;
    scrollToHash(hash);
  };

  return { scrollToElement };
};

export default useHashScroll;
